jQuery( function ( $ ) {

    if ( $(window).width() >= 992 ) {
        $( '.hero-banner.type-video video' ).each( function () {
            this.play();
        });
    }

});